const AISEOIcon = () => {
    return (
        <svg width="60" height="60" viewBox="5 0 60 60" xmlns="http://www.w3.org/2000/svg">
            <rect x="10" y="14" width="44" height="34" rx="10" stroke="#5C5F62" strokeWidth="4" fill="none" />
            <rect x="24" y="6" width="16" height="10" rx="5" stroke="#5C5F62" strokeWidth="4" fill="none" />
            <circle cx="24" cy="31" r="5" fill="#5C5F62" />
            <circle cx="40" cy="31" r="5" fill="#5C5F62" />
        </svg>
    )
}
export default AISEOIcon;

